import React from 'react';
import { PreviewProps } from '../../LandingPagePreview';
import MainColumnPreview, {
  MainColumnPreviewprops,
} from '../Shared/MainColumnPreview';
import Breathing from '~/App/Components/Shared/Breathing';
import VideoPlayerPreview from '../Shared/VideoPlayerPreview';
import styled from '@emotion/styled';
import Logo from '../Shared/Logo';
import SocialSharing from '../Shared/SocialSharing';
import EmbedsPreview from '../Shared/EmbedPreviews';
import { assetUrl } from '~/helpers';
import UserProfile from '../Shared/UserProfile';
import MessageContent from '../Shared/MessageContent';
import { BonjoroBadgeDesktop } from '~/App/Components/BonjoroBadgeDesktop';
import { SentWithBonjoroBadgeSize } from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';
import { SentWithBonjoroBadgeStyle } from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';
import LayoutPreview from '../Components/LayoutPreview';

const Sidebar = styled.div`
  display: flex;
  height: 100%;
  width: 250px;
  background: #ffffff;
  flex-direction: column;
  box-shadow: 0px 3px 6px #00000029;
  overflow: hidden;
`;

const MainContent = styled.div`
  width: 100%;
  max-width: 390px;
  margin: 20px auto 0;

  @media (max-width: 1140px) {
    max-width: 80%;
  }
`;

const VideoPlayerPreviewWrapper = styled.div`
  position: relative;
  margin-bottom: 10px;
  height: 210px;
`;

const ReplyPreview = styled.div`
  border-top: 1px solid #e6e6e6;
  padding: 13px;
`;

const PreviewWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;
`;

const MessageWrapper = styled.div`
  flex: 1;
  margin: 0 13px;
`;

interface StyledMainColumnPreviewProps extends MainColumnPreviewprops {
  embedCount?: number;
}

const StyledMainColumnPreview = styled(
  MainColumnPreview
)<StyledMainColumnPreviewProps>`
  display: flex;
  width: 100%;

  ${(props) =>
    !props.embedCount || props.embedCount < 2 ? 'align-items: center;' : ''}
`;

const NextGen = (props: PreviewProps) => {
  const {
    backgroundUrl,
    highlight,
    logoUrl,
    playerImage,
    ctaText,
    secondaryColor,
    ctaUrl,
    showCta,
    color,
    userShortName,
    userName,
    message,
    userImage,
    showSocialSharing,
    showBonjoroBadge,
    embeds,
    hidePreviewTag,
  } = props;

  return (
    <>
      <PreviewWrapper>
        <StyledMainColumnPreview
          centered={false}
          backgroundUrl={backgroundUrl as string}
          embedCount={embeds?.size}
        >
          <MainContent>
            <Breathing
              active={highlight === 'logo'}
              componentClass={Logo}
              logoUrl={logoUrl}
            />
            <VideoPlayerPreviewWrapper>
              <VideoPlayerPreview playerImage={playerImage || ''} />
              {showSocialSharing && <SocialSharing />}
            </VideoPlayerPreviewWrapper>
            {embeds && embeds?.size > 0 && <EmbedsPreview embeds={embeds} />}
          </MainContent>
        </StyledMainColumnPreview>
        {showBonjoroBadge && (
          <BonjoroBadgeDesktop
            className='absolute bottom-0 left-1/2 -translate-x-1/2 z-[105] zoom-[0.6]'
            size={SentWithBonjoroBadgeSize.Large}
            style={SentWithBonjoroBadgeStyle.Full}
            cssStyle={{
              zoom: '0.6',
            }}
          />
        )}
      </PreviewWrapper>
      <Sidebar>
        <UserProfile
          shadowed
          showSocialShare={false}
          userImage={userImage}
          userName={userName}
        />
        <MessageWrapper>
          <MessageContent
            userShortName={userShortName}
            message={message}
            highlight={highlight}
            ctaText={ctaText}
            secondaryColor={secondaryColor}
            ctaUrl={ctaUrl}
            showCta={showCta}
            color={color}
          />
        </MessageWrapper>
        <ReplyPreview>
          <img
            src={assetUrl('assets/images/message-template/reply-preview.svg')}
          />
        </ReplyPreview>
      </Sidebar>
      {!hidePreviewTag && <LayoutPreview />}
    </>
  );
};

export default NextGen;
